export default defineAppConfig({
  ui: {
    color: {
      primary: 'orange',
      gray: 'cool',
      neutral: 'white',
    },
    font: {
      sans: 'Inter',
    },
    button: {
      default: {
        font: 'font-bold',
        size: {
          xs: 'text-xs',
          sm: 'text-sm',
          md: 'text-sm',
          lg: 'text-base',
          xl: 'text-lg',
        },
        color: 'orange',
      },
    },
    card: {
      rounded: 'rounded-sm',
    },
    accordion: {
      slots: {
        root: 'w-full',
        item: 'border-b border-[var(--ui-border)] last:border-b-0',
        header: 'flex',
        trigger:
          'group flex-1 flex items-center gap-1.5 font-medium text-sm py-3.5 focus-visible:outline-[var(--ui-primary)] min-w-0',
        content:
          'data-[state=open]:animate-[accordion-down_200ms_ease-out] data-[state=closed]:animate-[accordion-up_200ms_ease-out] overflow-hidden focus:outline-none',
        body: 'text-sm pb-3.5 text-gray-600',
        leadingIcon: 'shrink-0 size-5',
        trailingIcon: 'shrink-0 size-5 ms-auto group-data-[state=open]:rotate-180 transition-transform duration-200',
        label: 'text-start break-words font-semibold text-lg cursor-pointer',
      },
      variants: {
        disabled: {
          true: {
            trigger: 'cursor-not-allowed opacity-75',
          },
        },
      },
    },
    xtable: {
      slots: {
        root: 'relative overflow-auto',
        base: 'min-w-full overflow-clip',
        caption: 'sr-only',
        thead:
          'relative [&>tr]:after:absolute [&>tr]:after:inset-x-0 [&>tr]:after:bottom-0 [&>tr]:after:h-px [&>tr]:after:bg-[var(--ui-border-accented)]',
        tbody: 'divide-y divide-[var(--ui-border)]',
        tr: 'data-[selected=true]:bg-[var(--ui-bg-elevated)]/50',
        th: 'px-4 py-3.5 text-sm text-[var(--ui-text-highlighted)] text-left rtl:text-right font-semibold [&:has([role=checkbox])]:pe-0',
        td: 'p-4 text-sm text-[var(--ui-text-muted)] whitespace-nowrap [&:has([role=checkbox])]:pe-0',
        empty: 'py-6 text-center text-sm text-[var(--ui-text-muted)]',
      },
      variants: {
        pinned: {
          true: {
            th: 'sticky bg-[var(--ui-bg)]/75 data-[pinned=left]:left-0 data-[pinned=right]:right-0',
            td: 'sticky bg-[var(--ui-bg)]/75 data-[pinned=left]:left-0 data-[pinned=right]:right-0',
          },
        },
        sticky: {
          true: {
            thead: 'sticky top-0 inset-x-0 bg-[var(--ui-bg)]/75 z-[1] backdrop-blur',
          },
        },
        loading: {
          true: {
            thead: 'after:absolute after:bottom-0 after:inset-x-0 after:h-px',
          },
        },
        loadingAnimation: {
          'carousel': '',
          'carousel-inverse': '',
          'swing': '',
          'elastic': '',
        },
        loadingColor: {
          primary: '',
          secondary: '',
          success: '',
          info: '',
          warning: '',
          error: '',
          neutral: '',
        },
      },
      compoundVariants: [
        {
          loading: true,
          loadingColor: 'primary',
          class: {
            thead: 'after:bg-[var(--ui-primary)]',
          },
        },
        {
          loading: true,
          loadingColor: 'neutral',
          class: {
            thead: 'after:bg-[var(--ui-bg-inverted)]',
          },
        },
        {
          loading: true,
          loadingAnimation: 'carousel',
          class: {
            thead:
              'after:animate-[carousel_2s_ease-in-out_infinite] rtl:after:animate-[carousel-rtl_2s_ease-in-out_infinite]',
          },
        },
        {
          loading: true,
          loadingAnimation: 'carousel-inverse',
          class: {
            thead:
              'after:animate-[carousel-inverse_2s_ease-in-out_infinite] rtl:after:animate-[carousel-inverse-rtl_2s_ease-in-out_infinite]',
          },
        },
        {
          loading: true,
          loadingAnimation: 'swing',
          class: {
            thead: 'after:animate-[swing_2s_ease-in-out_infinite]',
          },
        },
        {
          loading: true,
          loadingAnimation: 'elastic',
          class: {
            thead: 'after:animate-[elastic_2s_ease-in-out_infinite]',
          },
        },
      ],
      defaultVariants: {
        loadingColor: 'primary',
        loadingAnimation: 'carousel',
      },
    },
    page: {
      slots: {
        root: 'flex flex-col lg:grid lg:grid-cols-12 lg:gap-10',
        left: 'lg:col-span-2',
        center: 'lg:col-span-8',
        right: 'lg:col-span-4 order-first lg:order-last',
      },
      variants: {
        left: {
          true: '',
        },
        right: {
          true: '',
        },
      },
      compoundVariants: [
        {
          left: true,
          right: true,
          class: {
            center: 'lg:col-span-6',
          },
        },
        {
          left: false,
          right: false,
          class: {
            center: 'lg:col-span-10',
          },
        },
      ],
    },
  },
})
